import { PAPER_RIGHT_PADDING } from "src/components/paper";

enum SidebarKey {
  Analytics = "analytics-sidebar-open",
  General = "sidebar-open", // non-page-specific
  AiInsights = "ai-insights-sidebar-open",
  SchemaSearch = "schema-sidebar-open",
  SchemaFirstModelInteraction = "schema-sidebar-first-model-interaction",
  AssetsFilters = "assets-filters-sidebar-open",
}

enum SidebarName {
  Filter = "filter bar",
  Search = "search sidebar",
  Variables = "variables",
  AudienceAgent = "agent sidebar",
  AudienceInsights = "insights sidebar",
  CampaignCalendarAgent = "campaign calendar agent sidebar",
  IdrAgent = "identity graph agent sidebar",
  JourneyAgent = "journey agent sidebar",
  ProjectsAgent = "projects agent sidebar",
  ActionsAgent = "actions agent sidebar",
  ContextAgent = "context agent sidebar",
}
const PAGE_SIDEBAR_COLLAPSED_WIDTH_PX = "40px";
const PAGE_SIDEBAR_OPEN_WIDTH_PX = "280px";

// Vertically center sidebar content by balancing left and right padding with the page card.
const PAGE_SIDEBAR_LEFT_PADDING = 1;
const PAGE_SIDEBAR_RIGHT_PADDING =
  PAPER_RIGHT_PADDING + PAGE_SIDEBAR_LEFT_PADDING;

export {
  SidebarKey,
  SidebarName,
  PAGE_SIDEBAR_COLLAPSED_WIDTH_PX,
  PAGE_SIDEBAR_OPEN_WIDTH_PX,
  PAGE_SIDEBAR_LEFT_PADDING,
  PAGE_SIDEBAR_RIGHT_PADDING,
};
